/**
 * PrivacySettings — a small set of toggles controlling what a public
 * profile reveals. Standalone so it can be reused inside EditProfileModal
 * or, later, a dedicated settings page.
 */

import React from 'react';
import { Switch } from '@/components/ui/switch';

const OPTIONS = [
  { key: 'publicProfile', label: 'Public profile', hint: 'Anyone can view your profile, shelves, and scribbles.' },
  { key: 'showReadingActivity', label: 'Show reading activity', hint: 'Let others see what you’re currently reading and your progress.' },
  { key: 'showEmail', label: 'Show email on profile', hint: 'Display your email address to visitors.' },
];

export default function PrivacySettings({ privacy, onChange }) {
  return (
    <div className="space-y-1">
      {OPTIONS.map((opt) => (
        <div key={opt.key} className="flex items-center justify-between gap-4 border-b border-line py-3.5 last:border-b-0">
          <div className="min-w-0">
            <p className="text-sm font-medium text-ink">{opt.label}</p>
            <p className="mt-0.5 text-xs text-subtle">{opt.hint}</p>
          </div>
          <Switch
            checked={!!privacy?.[opt.key]}
            onCheckedChange={(checked) => onChange({ [opt.key]: checked })}
            aria-label={opt.label}
            className="shrink-0 data-[state=checked]:bg-coral"
          />
        </div>
      ))}
    </div>
  );
}
